const buttonOpenVisaList = document.querySelector(".visa__free__open");
const buttonCloseVisaList = document.querySelectorAll(
  ".visa__free__block__close"
);

if (buttonOpenVisaList) {
  buttonOpenVisaList.addEventListener("click", (e) => {
    e.preventDefault();
    buttonOpenVisaList.parentNode.classList.add("active");
    document.querySelector(".visa__free__block").classList.add("open");
    document.querySelector("body").classList.add("body-visa");
  });
}

if (buttonCloseVisaList) {
  buttonCloseVisaList.forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      document.querySelector(".visa__free__block").classList.remove("open");
      document.querySelector("body").classList.remove("body-visa");
    });
  });
}
